export enum TransactionsEnum {
    Deliveries = "_", //it's DIESEL_OUT
    Transaction = "_IN",
    Transfer = "_TRF"
}